<ion-app>
  <ion-menu side="start" menuId="menu" content-id="landing" class="app-menu">

    <!-- Header -->
    <div class="menu-header">
      <img class="menu-badge-bg" src="assets/img/pcs-badge.png" alt="" aria-hidden="true" />
      <ion-menu-toggle menu="menu">
        <button class="menu-close-btn" aria-label="Close menu">
          <ion-icon name="close" style="font-size:16px;"></ion-icon>
        </button>
      </ion-menu-toggle>
      <div class="menu-user-row">
        <div class="menu-avatar">
          <img *ngIf="profileImg?.imageUrl" [src]="profileImg.imageUrl" class="menu-avatar-img" alt="Profile photo" />
          <span *ngIf="!profileImg?.imageUrl">{{ initials }}</span>
        </div>
        <div class="menu-user-info">
          <div class="menu-user-name">{{ captainName }}</div>
          <div class="menu-user-role">{{ badgeText }}</div>
        </div>
      </div>
      <div class="menu-status-chip">
        <ion-icon name="time-outline" style="font-size:13px;"></ion-icon>
        Active
      </div>
    </div>

    <ion-content>

      <!-- OVERVIEW GROUP -->
      <div class="menu-group" *appHasRole="['user', 'admin', 'manager', 'captain', 'mate', 'tech']">
        <ion-menu-toggle>
          <button class="menu-item" [class.active]="isActive('/private/home')" (click)="goToDashboard()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="home-outline"></ion-icon></span>
            <span class="menu-item-label">Home</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle *appHasRole="['user', 'admin', 'manager', 'captain']">
          <button class="menu-item" [class.active]="isActive('/private/select')" (click)="startNewReport()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="clipboard-outline"></ion-icon></span>
            <span class="menu-item-label">New Inspection</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle>
          <button class="menu-item" [class.active]="isActive('/private/view')" (click)="goToMyList()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="documents-outline"></ion-icon></span>
            <span class="menu-item-label">Assignments</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle *ngIf="apView">
          <button class="menu-item" [class.active]="isActive('/private/chat-main')" (click)="goToChats()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="chatbubbles-outline"></ion-icon></span>
            <span class="menu-item-label">Messages</span>
            <span class="menu-item-badge" *ngIf="msgNotifications > 0">{{ msgNotifications }}</span>
          </button>
        </ion-menu-toggle>
      </div>

      <!-- WORK GROUP -->
      <div class="menu-group">
        <div class="menu-group-label">Work</div>
        <ion-menu-toggle *appHasRole="['user', 'admin', 'manager', 'captain', 'mate', 'tech']">
          <button class="menu-item" [class.active]="isActive('/private/timeclock')" (click)="goToTimeClock()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="time-outline"></ion-icon></span>
            <span class="menu-item-label">Clock In / Out</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle *appHasRole="['user', 'admin', 'manager', 'captain', 'mate', 'tech']">
          <button class="menu-item" [class.active]="isActive('/private/timesheet')" (click)="goToTimesheet()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="calendar-outline"></ion-icon></span>
            <span class="menu-item-label">My Timesheet</span>
          </button>
        </ion-menu-toggle>
      </div>

      <!-- FLEET GROUP -->
      <div class="menu-group" *appHasRole="['user', 'admin', 'manager', 'captain', 'tech']">
        <div class="menu-group-label">Fleet</div>
        <ion-menu-toggle *appHasRole="['user', 'admin', 'manager', 'captain', 'tech']">
          <button class="menu-item" [class.active]="isActive('/private/boat-profile')" (click)="goToBoatProfile()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="boat-outline"></ion-icon></span>
            <span class="menu-item-label">Boats</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle *appHasRole="['admin']">
          <button class="menu-item" [class.active]="isActive('/private/client-list')" (click)="goToClients()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="people-outline"></ion-icon></span>
            <span class="menu-item-label">Clients</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle *appHasRole="['admin', 'manager']">
          <button class="menu-item" [class.active]="isActive('/private/assign')" (click)="goToAssignInspections()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="flash-outline"></ion-icon></span>
            <span class="menu-item-label">Assign Inspections</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle *appHasRole="['admin', 'manager']">
          <button class="menu-item" [class.active]="isActive('/private/service-requests')" (click)="goToServiceRequests()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="construct-outline"></ion-icon></span>
            <span class="menu-item-label">Requests / Trips</span>
          </button>
        </ion-menu-toggle>
      </div>

      <!-- ADMIN GROUP -->
      <div class="menu-group" *appHasRole="['admin']">
        <div class="menu-group-label">Admin</div>
        <ion-menu-toggle>
          <button class="menu-item" [class.active]="isActive('/private/options')" (click)="goToAdmin()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="settings-outline"></ion-icon></span>
            <span class="menu-item-label">Admin Dashboard</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle>
          <button class="menu-item" [class.active]="isActive('/private/payroll')" (click)="goToPayroll()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="cash-outline"></ion-icon></span>
            <span class="menu-item-label">Payroll</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle>
          <button class="menu-item" [class.active]="isActive('/private/timecards')" (click)="goToTimeCards()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="timer-outline"></ion-icon></span>
            <span class="menu-item-label">Time Cards</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle>
          <button class="menu-item" [class.active]="isActive('/private/users')" (click)="goToAddNewUser()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="finger-print-outline"></ion-icon></span>
            <span class="menu-item-label">User Management</span>
          </button>
        </ion-menu-toggle>
      </div>

      <!-- RESOURCES GROUP -->
      <div class="menu-group">
        <div class="menu-group-label">Resources</div>
        <ion-menu-toggle>
          <button class="menu-item" (click)="goToPCSHandbook()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="book-outline"></ion-icon></span>
            <span class="menu-item-label">PCS Handbook</span>
          </button>
        </ion-menu-toggle>
        <ion-menu-toggle *appHasRole="['admin', 'manager']">
          <button class="menu-item" [class.active]="isActive('/private/videos')" (click)="goToTrainingVideos()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="videocam-outline"></ion-icon></span>
            <span class="menu-item-label">Training Videos</span>
          </button>
        </ion-menu-toggle>
      </div>

      <!-- ACCOUNT GROUP -->
      <div class="menu-group">
        <div class="menu-group-label">Account</div>
        <ion-menu-toggle>
          <button class="menu-item" [class.active]="isActive('/private/profile')" (click)="goToProfile()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="person-outline"></ion-icon></span>
            <span class="menu-item-label">My Profile</span>
          </button>
        </ion-menu-toggle>
      </div>

      <!-- DEV GROUP -->
      <div class="menu-group" *ngIf="isDev">
        <div class="menu-group-label">Developer</div>
        <ion-menu-toggle>
          <button class="menu-item" (click)="consoleLogs()">
            <span class="menu-item-bar"></span>
            <span class="menu-icon-tile"><ion-icon name="code-slash-outline"></ion-icon></span>
            <span class="menu-item-label">Console Logs</span>
          </button>
        </ion-menu-toggle>
      </div>

    </ion-content>

    <!-- Footer -->
    <ion-footer class="menu-footer">
      <div class="menu-version-block">
        <div class="menu-version-label">Version</div>
        <div class="menu-version-value">ProCap {{ currentApplicationVersion }}</div>
      </div>
      <ion-menu-toggle>
        <button class="menu-signout-btn" (click)="logout()">
          <ion-icon name="log-out-outline" style="font-size:14px;"></ion-icon>
          Sign out
        </button>
      </ion-menu-toggle>
    </ion-footer>

  </ion-menu>

  <ion-menu side="end" [type]="menuType" menuId="contacts" contentId="landing" *ngIf="showUsers">
    <ion-header>
      <ion-toolbar>
        <ion-title>Users in Chat</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list class="listClass">
        <ion-item lines="none" *ngFor="let i of chatUsers" (click)="confirmKick(i)">
          <ion-avatar slot="start">
            <img class="logo" *ngIf="i.pic; else placeholder_avatar;" [src]="i.pic" />
            <ng-template #placeholder_avatar>
              <img class="logo" src="./assets/img/default-avatar.jpg" />
            </ng-template>
          </ion-avatar>
          <ion-label>
            {{i.user}}
          </ion-label>
        </ion-item>
        <hr>
        <ion-item lines="none" (click)="backConfirm()">
          <ion-icon class="iconColor" name="exit-outline" slot="end"></ion-icon>
          <ion-label>Leave Chat</ion-label>
        </ion-item>
        <ion-item class="chatIdData" lines="none" *appHasRole="['admin']">
          <ion-label>Chat ID: {{chatId}}</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="landing">
  </ion-router-outlet>
</ion-app>
